/**
 * Account settings domain types + option catalogue.
 *
 * UI-only for now — seeded via accountSettingsSlice + AccountSettingsInitializer.
 * TODO(backend): name/email → profile endpoint (events/api/v1/profile/),
 * password → auth change-password endpoint, session timeout → AuthGuard idle
 * timeout. Wire each when its endpoint is confirmed.
 *
 * NOTE: passwords are never stored here — they stay transient in the form.
 */

export type SessionTimeout =
  | "15_min"
  | "30_min"
  | "1_hour"
  | "2_hours"
  | "3_hours"
  | "4_hours"
  | "never";

export interface AccountSettings {
  firstName: string;
  lastName: string;
  email: string;
  sessionTimeout: SessionTimeout;
}

export const SESSION_TIMEOUT_OPTIONS = [
  { label: "15 minutes", value: "15_min" },
  { label: "30 minutes", value: "30_min" },
  { label: "1 hour", value: "1_hour" },
  { label: "2 hours", value: "2_hours" },
  { label: "3 hours", value: "3_hours" },
  { label: "4 hours", value: "4_hours" },
  { label: "Never", value: "never" },
];

export function defaultAccountSettings(): AccountSettings {
  return {
    firstName: "",
    lastName: "",
    email: "",
    sessionTimeout: "1_hour",
  };
}
